import { IInvoice } from "@faire/web-api/indigofair/data/IInvoice";
export var orderWasAlreadyCharged = function orderWasAlreadyCharged(brandOrder) {
  return brandOrder.invoice_state === IInvoice.State.PAID;
};